/*jshint esversion: 11 */
import React from 'react';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Alert,
  Input
} from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

const ChildFilterModal = ({
  filterError,
  setFilterError,
  modalOpenState,
  closeModalHandler,
  fetchList,
  updateFilterCount,
  childName,
  setChildName,
  childDob,
  setChildDob,
  childGender,
  setChildGender,
  addressLocation,
  setAddressLocation,
  createQueryOptions,
  setChildPhone,
  childPhone,
  setChildEmail,
  childEmail,
  setRollNo,
  rollNo,
  authUser,
  isDeleted,
  setIsDeleted,
  isProfileCompleted,
  setIsProfileCompleted,
  filterHasParent,
  setFilterHasParent,
  filterHasProfilePicture = '',
  setFilterHasProfilePicture = () => {},
  offeringOptions = [],
  selectedOfferingOption = [],
  setOfferingOption = () => {},
  setOfferingQueryId = () => {},
}) => {
  function applyFilter() {
    const offeringIds = selectedOfferingOption.map((i) => i.value._id);
    setOfferingQueryId(offeringIds);
    const queryOptions = createQueryOptions(
      childDob.startDate,
      childDob.endDate,
      childName,
      childPhone,
      childEmail,
      rollNo,
      childGender,
      addressLocation,
      isDeleted,
      isProfileCompleted,
      filterHasParent,
      filterHasProfilePicture,
      selectedOfferingOption
    );
    if (queryOptions) {
      updateFilterCount(queryOptions);
      fetchList(1, null, queryOptions, queryOptions.sorting_option);
      closeModalHandler();
    }
  }

  function clearFilter() {
    setChildDob({
      startDate: null,
      endDate: null
    });
    setAddressLocation('');
    setChildEmail('');
    setChildGender('');
    setChildName('');
    setChildPhone('');
    setRollNo('');
    setIsDeleted(false);
    setIsProfileCompleted('');
    setFilterHasParent('');
    setFilterHasProfilePicture('');
    setOfferingOption([]);
    setOfferingQueryId([]);
    const queryOptions = createQueryOptions(
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      '',
      '',
      '',
      []
    );
    if (queryOptions) {
      updateFilterCount(queryOptions);
      fetchList(1, null, queryOptions);
      closeModalHandler();
    }
  }

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 100
    })
  };

  return (
    <React.Fragment>
      <Modal isOpen={modalOpenState} backdrop="static" size="md">
        <ModalHeader toggle={closeModalHandler}>Filter Children</ModalHeader>
        <ModalBody>
          {filterError ? (
            <Alert
              color="danger"
              role="alert"
              isOpen={filterError ? true : false}
              toggle={() => setFilterError(false)}
            >
              <i className="mdi mdi-block-helper mr-2"></i>
              {filterError}
            </Alert>
          ) : null}
          <AvForm className="needs-validation" onValidSubmit={applyFilter}>
            <Row>
              <Col md="12">
                <FormGroup>
                  <Label>Roll No</Label>
                  <AvField
                    name="roll_no"
                    placeholder="Enter Exact Roll No ..."
                    type="text"
                    className="form-control"
                    onChange={(e) => setRollNo(e.target?.value)}
                    value={rollNo}
                  />
                </FormGroup>
              </Col>
              <Col md="12">
                <FormGroup>
                  <Label>Offering</Label>
                  <Select
                    options={offeringOptions}
                    onChange={(e) => setOfferingOption(e || [])}
                    value={selectedOfferingOption}
                    components={animatedComponents}
                    styles={selectStyles}
                    isMulti
                  />
                </FormGroup>
              </Col>
              <Col md="12">
                <FormGroup>
                  <Label>Child Name</Label>
                  <AvField
                    name="child_name"
                    placeholder="Enter Child Name ..."
                    type="text"
                    className="form-control"
                    onChange={(e) => setChildName(e.target?.value)}
                    value={childName}
                  />
                </FormGroup>
              </Col>
              <Col md="12">
                <FormGroup>
                  <Label>Phone Number</Label>
                  <AvField
                    name="phone_number"
                    placeholder="Enter Phone Number ..."
                    type="text"
                    className="form-control"
                    onChange={(e) => setChildPhone(e.target?.value)}
                    value={childPhone}
                  />
                </FormGroup>
              </Col>
              <Col md="12">
                <FormGroup>
                  <Label>Email Address</Label>
                  <AvField
                    name="email_address"
                    placeholder="Enter Email Address ..."
                    type="text"
                    className="form-control"
                    onChange={(e) => setChildEmail(e.target?.value)}
                    value={childEmail}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label>Gender</Label>
                  <select
                    className="form-control"
                    onChange={(e) => {
                      setChildGender(e.target?.value);
                    }}
                    value={childGender || ''}
                  >
                    <option value="">None</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label>Location</Label>
                  <select
                    className="form-control"
                    onChange={(e) => {
                      setAddressLocation(e.target?.value);
                    }}
                    value={addressLocation || ''}
                  >
                    <option value="">All</option>
                    <option value="Kandivali">Kandivali</option>
                    <option value="Malad">Malad</option>
                    <option value="Borivali">Borivali</option>
                    <option value="Other">Other</option>
                  </select>
                </FormGroup>
              </Col>
        
              <Col md="6">
                <FormGroup className='w-100'>
                  <Label>Profile Completed</Label>
                  <select
                    className="form-control"
                    onChange={(e) => {
                      setIsProfileCompleted(e.target?.value);
                    }}
                    value={isProfileCompleted || ''}
                  >
                    <option value="">None</option>
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </select>
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup className='w-100'>
                  <Label>Parent Assigned</Label>
                  <select
                    className="form-control"
                    onChange={(e) => {
                      setFilterHasParent(e.target?.value);
                    }}
                    value={filterHasParent || ''}
                  >
                    <option value="">None</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup className='w-100'>
                  <Label>Profile Picture Assigned</Label>
                  <select
                    className="form-control"
                    onChange={(e) => {
                      setFilterHasProfilePicture(e.target?.value);
                    }}
                    value={filterHasProfilePicture || ''}
                  >
                    <option value="">None</option>
                    <option value="true">Yes (custom photo)</option>
                    <option value="false">No (missing or default)</option>
                  </select>
                </FormGroup>
              </Col>
              {authUser && authUser.user_type === 'super_admin' && (
                <Col md="6">
                  <FormGroup>
                    <Label>Is Terminated</Label>
                    <div
                      className="custom-control custom-switch mb-2"
                      dir="ltr"
                    >
                      <Input
                        id="customSwitch"
                        name="isComplted"
                        type="checkbox"
                        className="custom-control-input p-3"
                        checked={isDeleted}
                        onChange={() => setIsDeleted(!isDeleted)}
                      />
                      <Label
                        htmlFor="customSwitch"
                        className="custom-control-label"
                      >
                        Terminated Children
                      </Label>
                    </div>
                  </FormGroup>
                </Col>
              )}
           

            </Row>
            <Row className="d-flex px-3" style={{ height: '100%' }}></Row>
            <ModalFooter>
              <Button size="sm" type="submit" color="primary">
                Apply Filter
              </Button>
              <Button
                size="sm"
                type="button"
                color="success"
                onClick={() => clearFilter()}
              >
                Reset
              </Button>
              <Button
                size="sm"
                type="button"
                color="light"
                onClick={closeModalHandler}
              >
                Close
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(ChildFilterModal);